import { _param, getWorkflowParam } from "src/main";
import { Overlay } from "../overlay";
import { makeElement } from "./layer_gene_table_tab";
import './viewer_settings.css';
import './open_files_dialog.less';
import { TrackableBoolean } from "../trackable_boolean";
// import { message } from "../widget/message";
// import i18n from "../i18n/i18n";
// import { cancellableFetchSpecialOk } from "../util/special_protocol_request";
// import { responseJson } from "../util/http_request";

/**
 * @name:worlflow弹窗
 * @type: lasso/register
 * @param: 运行参数
 */
export class registerLassoOpenDialog extends Overlay {
  iframe = document.createElement('iframe');
  buttonOpenFilesConform: HTMLElement | null;
  loading = makeElement('div',['loader']);
  is_loaded = new TrackableBoolean(false, false);
  constructor(type: string, param: any){
    super();
    this.initDom(type, param);
  }
  initDom(type: string, param: any){
    this.loading.style.position = 'absolute';
    this.content.appendChild(this.loading);
    this.content.style.display = 'contents';
    this.loading.style.display = 'none';
    const iframeContainer = makeElement('div', ['iframe_container'], {style: 'margin:0;padding:0'});
    iframeContainer.style.width = '100%';
    iframeContainer.style.height = '100%';
    this.content.appendChild(iframeContainer);
    // const stomicsDomain = 'http://dev/ngdataserverv3/';
    const stomicsDomain = process.env.domainConfig![process.env.NODE_ENV!].stomicsDomain;
    this.iframe.src = `${stomicsDomain}#/sto-run-task?projectId=${_param.projectId}&tag=V3&src=stereomap&token=${localStorage.getItem('ksh_token')}&session=${localStorage.getItem('skfx_session')}&defaultZone=${_param.zone || ''}&defaultLang=${sessionStorage.getItem('lang') || 'en'}`;
    iframeContainer.appendChild(this.iframe);
    this.content.classList.add('open_files_container');
    this.is_post_param(type, param);
  }
  is_post_param(type: string, param: any){
    this.iframe.contentWindow!.postMessage({'workflow_manualtools': {'lasso': param}}, '*');
    this.is_loaded.changed.add(()=>{
      if(this.is_loaded.value){
        this.loading.style.display = 'none';
        this.get_tools_info(type, param);
      }
    })
  }
  async get_tools_info(type: string, param: any){
    // const bodyParam = {
    //   src: 'SteroMap',
    //   type: 'params',
    //   value: param
    // }
    if(type === 'lasso'){
      console.log('发送postmessage信息workflow_manualtools：lasso -> ',param)
      this.iframe.contentWindow!.postMessage({'workflow_manualtools': param}, '*');
    }else if(type === 'register'){
      const workflow_param = await getWorkflowParam('register');
      const key = param.register ? 'register' : param.pt_v1 ? 'pt_v1' : 'register_v7';
      param[key].value['DataDir'] = workflow_param.DataDir;
      param[key].value['ImageTar'] = workflow_param.ImageTar;
      param[key].value['ImagePreDir'] = workflow_param.ImagePreDir;
      param[key].value['Tissue'] = workflow_param.Tissue;
      param[key].value['Reference'] = workflow_param.Reference;
      param[key].value['Cellbin'] = workflow_param.Cellbin || false;
      console.log('发送postmessage信息workflow_manualtools：register -> ',param)
      this.iframe.contentWindow!.postMessage({'workflow_manualtools': param}, '*');
    } else if (type === 'MIDfilter') {
      console.log('发送postmessage信息workflow_manualtools：MIDfilter -> ',param)
      this.iframe.contentWindow!.postMessage({'workflow_manualtools': param}, '*');
    }
  }
  dispose() {
    super.dispose();
  }
}